import type { IttCartItem } from '@hyundai/shared-lib';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { ApiTypes } from '../../..';

export const vehicleActions = createActionGroup({
    source: 'vehicle',
    events: {
        Init: props<{ initalFilter?: ApiTypes.FilterObject }>(),
        Filter: emptyProps(),
        'Reset Filter': emptyProps(),

        'Load Vehicle List': emptyProps(),
        'Load Vehicle List Success': props<{ list: ApiTypes.VehicleList }>(),
        'Load Vehicle List Failure': props<{ error: string }>(),

        'Load Similar Vehicle List': emptyProps(),
        'Load Similar Vehicle List Success': props<{ list: ApiTypes.VehicleList }>(),
        'Load Similar Vehicle List Failure': props<{ error: string }>(),

        'Load Number Of Vehicles': emptyProps(),
        'Load Number Of Vehicles Success': props<{ count: number }>(),
        'Load Number Of Vehicles Failure': props<{ error: string }>(),

        'Load Vehicle Detail': props<{ slug: string }>(),
        'Load Vehicle Detail Success': props<{ vehicle: ApiTypes.VehicleDetail }>(),
        'Load Vehicle Detail Failure': props<{ error: string }>(),

        'Load Filter': emptyProps(),
        'Load Filter Success': props<{ filterInputs: ApiTypes.VehicleFilterInputs }>(),
        'Load Filter Failure': props<{ error: string }>(),

        'Load Filter Preview Number Of Vehicles': emptyProps(),
        'Load Filter Preview Number Of Vehicles Success': props<{ count: number }>(),
        'Load Filter Preview Number Of Vehicles Failure': props<{ error: string }>(),

        'Add Filter': props<{ filterObject: ApiTypes.FilterObject; trackingKeys: string[] }>(),
        'Remove Filter': props<{ removeFilterObject: Array<keyof ApiTypes.FilterObject>; trackingKeys: string[] }>(),
        'Reset Preview Filter': emptyProps(),

        'Set Accessory Cart': props<{ newCart: IttCartItem[] }>(),

        'Reset Tracking Keys': emptyProps(),
    },
});
